module.exports = __webpack_public_path__ + "static/media/Project1_Demo10.2724864c.png";